// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchSkyfireMethods } from '../utils';
import * as Styles from './Notification.scss';
import TextWithLink from './widgets/items/TextWithLink';
export default function NotificationRibbon(props) {
    var _a, _b, _c, _d, _e;
    useStyles(Styles);
    const dispatch = useDispatch();
    const { ribbon } = useSelector((state) => state.Ribbon);
    const { mediaId } = useSelector((state) => state.Media);
    const { overlayTemplates } = useSelector((state) => state.TemplateStack);
    const hasOverlay = overlayTemplates.length > 0;
    if (!ribbon || hasOverlay && overlayTemplates[0].interface !== props.template.interface) {
        return null;
    }
    const closeCallback = useCallback((event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        const { onItemSelected } = ribbon.closeButton;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, ribbon]);
    const leftButtonCallback = useCallback((event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        const { onItemSelected } = ribbon.leftButton.primaryLink;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, ribbon]);
    const rightButtonCallback = useCallback((event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        const { onItemSelected } = ribbon.rightButton.primaryLink;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, ribbon]);
    useEffect(() => {
        const timer = setTimeout(() => {
            closeCallback();
        }, ribbon.timeoutMilliseconds);
        return () => clearTimeout(timer);
    }, [ribbon]);
    useEffect(() => {
        dispatchSkyfireMethods(dispatch, props.template, ribbon.onViewed);
    }, [ribbon]);
    const leftButton = ribbon.leftButton && (React.createElement("music-button", { href: ribbon.leftButton.primaryLink.deeplink, onClick: leftButtonCallback, slot: "buttons", variant: "outline" }, ribbon.leftButton.text));
    const rightButton = ribbon.rightButton && (React.createElement("music-button", { href: ribbon.rightButton.primaryLink.deeplink, onClick: rightButtonCallback, slot: "buttons", variant: "outline" }, ribbon.rightButton.text));
    const transportHeight = 85;
    const bottomPosition = mediaId ? transportHeight : 0;
    return (React.createElement("music-notification-ribbon", { style: { bottom: `${bottomPosition}px` }, kind: "accent", closable: !!((_a = ribbon) === null || _a === void 0 ? void 0 : _a.closeButton), onmusicRibbonCloseButtonActivate: closeCallback }, (_c = (_b = ribbon.message) === null || _b === void 0 ? void 0 : _b.text, (_c !== null && _c !== void 0 ? _c : (_e = (_d = ribbon.message) === null || _d === void 0 ? void 0 : _d.textWithLinks) === null || _e === void 0 ? void 0 : _e.map((textWithLinkElement) => (React.createElement(TextWithLink, { data: textWithLinkElement, template: props.template }))))),
        leftButton,
        rightButton));
}
;
